<template>
  <div class="index">
      <div class="header">
        <div class="header-one">
          <div class="mytitle">模拟图系统软件V1.0</div>
        </div>
        <div class="left">
          <router-link :to="{name:'mapList'}" >模拟图列表 </router-link>
          <router-link :to="{name:'componentList'}"  v-if="usertype==1"> 元器件列表 </router-link>
          <!-- <router-link :to="{name:'makeMap'}" >模拟图管理</router-link> -->
          <router-link :to="{name:'warn'}"  >异常提醒</router-link>
          <router-link :to="{name:'userMange'}" v-if="usertype==1">用户管理 </router-link>
          <router-link :to="{name:'system'}" v-if="usertype==1">系统设置 </router-link>
        </div>
        <div class="header-two">
          <div class="myimg">
            <img src="../assets/user.jpg" alt="" v-if="usertype==1">
            <img src="../assets/user_1.jpg" alt="" v-else>
          </div>
          <div>{{username}}</div>
          <!-- <div class="warn">{{number}}</div> -->
          <!-- <div class="up" style="width:0px;height:0px;"></div> -->
          <div class="menu">
            <div @click="userInfo">修改密码</div>
            <div @click="confirm">退出登录</div>
            <!-- <div @click="typeList">修改类型</div>
            <div @click="lineList">修改接线</div> -->
            <!-- <div @click="warnList">提醒列表</div> -->
          </div>
        </div>
      </div>
      <div class="content"  ref="myHeight">
        <router-view></router-view>
      </div>
      <div class="mydialog">
        <el-dialog
          title="修改密码"
          :visible.sync="dialogVisible"
          width="560px"
          :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
              <el-form-item label="原密码" prop="oldPassWord" >
                <el-input v-model="ruleForm.oldPassWord" show-password maxlength="8"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPassWord">
                <el-input v-model="ruleForm.newPassWord" show-password maxlength="8"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button  @click="cancel('ruleForm')" class="mybtn">取 消</el-button>
                <el-button @click="comfir('ruleForm')" type="primary">确 定</el-button>
              </el-form-item>
            </el-form>
        </el-dialog>
      </div>
  </div>
</template>
<script>

export default {
    data () {
      return {
          clientHeight:"",
          clientWidth:"",
          dialogVisible:false,
          ruleForm:{
            oldPassWord:"",
            newPassWord:"",
          },
          rules:{
            newPassWord:[
              { required: true, message: '请输入新密码', trigger: 'blur' },
              { min: 6, max: 8, message: '长度在 6 到 8 个字符', trigger: 'blur' }
            ],
            oldPassWord:[{ required: true, message: '请输入原密码', trigger: 'blur' },]
          },
          userid:"",
          username:"",
          usertype:"",
          number:0,
          updateDialogVisible:false,

     }
   },
    computed:{
    },
    components:{
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        this.changeFixed(this.clientHeight)
      },

    },
    mounted(){
        // 获取浏览器可视区域高度、宽度
      this.clientHeight =   `${document.documentElement.clientHeight}` -50 ;       
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`-50;
      };
      this.userid=JSON.parse(sessionStorage.getItem('userinfo')).id
      this.username=JSON.parse(sessionStorage.getItem('userinfo')).name
      this.usertype=JSON.parse(sessionStorage.getItem('userinfo')).type
      // this.getWarnInfo()
    },
    methods:{
      changeFixed(clientHeight){ //动态修改样式
        this.$refs.myHeight.style.height = clientHeight+'px';
      },

      //个人中心
      userInfo(){
        this.dialogVisible=true;
      },
      handleClose(){
        this.dialogVisible=false;
      },
      updateHandleClose(){
        this.updateDialogVisible=false
      },
      //确认
      comfir(ruleForm){
        var params={
          id:this.userid,
          newPassWord:this.$md5(this.ruleForm.newPassWord),
          oldPassWord:this.$md5(this.ruleForm.oldPassWord)
        }
          this.$refs[ruleForm].validate((valid) => {
            if (valid) {
              this.$api.updatepword(params,res=>{
                //console.log(res)
                if(res.errCode==0){
                    this.dialogVisible=false;
                    this.ruleForm.oldPassWord="";
                    this.ruleForm.newPassWord="";
                    this.$message({
                      message:"修改成功！",
                      type:'success',
                      duration:1500,
                      onClose:()=>{
                        this.$router.push({name:'login'})
                      }
                    })
                }else{
                  this.$message.error("修改失败，请检查密码格式是否正确！")
                  // this.dialogVisible=false;
                  // this.ruleForm.oldPassWord="";
                  // this.ruleForm.newPassWord="";
                }
              })
            } else {
              return false;
            }
          });
        
      },
      //取消
      cancel(ruleForm){
        this.$refs[ruleForm].resetFields();
        this.dialogVisible=false;
      },
      //退出登录
      confirm(){
        this.$router.push({name:'login'})
        sessionStorage.removeItem('userinfo')
      },
      //获取提醒信息
      getWarnInfo(){
        this.$api.getInfo({},res=>{
          //console.log(res)
          this.number=res.data.length
        })
      },
      // warnList(){
        
      // }
    }
}

</script>
<style scoped>
.warn{
  width: 30px;
  color: red;
}
.mydialog /deep/ .el-input{
  width: 350px;
}
.mydialog /deep/ .el-form-item__content{
  display: flex;
}
.mydialog /deep/ .el-form-item__label{
  margin-left:10%;
}
.mybtn{
  margin-left: 55%;
}
.myimg>img{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-top: 10px;
}
.content{
  width: 100%;
}
.content-title{
  display: flex;
  /* width: 1432px; */
  margin-left: 50px;
}
.linkto{
  color:#377bb5;
  cursor:pointer;
}
.header{
  height: 50px;
  background-color: #0b5288;
  color: aliceblue;
  display: flex;
  justify-content: space-between;
  line-height: 50px;
  width: 100%;
}
.mytitle{
  width: 180px;
}
.header-one{
  display: flex;
  margin-left: 50px;
  width: 20%;
}
.header-two{
  display: flex;
  cursor: pointer;
  position: relative;
  margin-right: 50px;
  width: 10%;
  font-size: 14px;
}
.header-two>div:first-child{
  margin-right: 10px;
}
.header-two>div:last-child{
  padding-top: 5px;
}

.mybg{
    height: 90%;
}
.left-title{
    width: 100%;
    height: 50px;
    color: #fff;
    line-height: 50px;
    font-size: 14px;
}
.content{
  background-color: #e7e8eb;
}
.content-title>div{
  height: 50px;
  line-height: 50px;
  border: 1px solid rgb(189, 187, 187);
}
.content-title>div:first-child{
  border-right: none;
}
.content-title>div:first-child{
  width: 20%;
  display: flex;
  background-color: #f9fafc;
}
.content-title>div:last-child{
  width: 75%;
  display: flex;
  background-color: #fff;
}
.bg{
  margin-top: 13px;
  padding-left: 10px;
  height: 22px;
}
.font-color{
  font-weight:600;
  color: black;
   margin-left: auto;
   margin-right: auto;
}
.left{
  display: flex;
  border-right: none;
  border-top: none;
  text-align: center;
  width: 70%;
}
.left>a{
   text-decoration: none;
   display: inline-block;
   width: 120px;
   height: 50px;
   line-height: 50px;
   color: #fff;
   font-size: 14px;
   margin-right: 1px;
   position: relative;
   transition: 0.5s;
   overflow: hidden;
   border-radius: 2px;
}
.router-link-exact-active ,.router-link-active{
  background-color: #377bb5;
}

a:hover{
  background-color: #377bb5;
}
/* a::before{
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-top: 2px solid #fff;
  border-left: 2px solid #fff;
  transition: 0.5s;
  transition-delay: 0.5s;
}
a:hover::before{
  width: 100%;
  height: 100%;
  transition-delay: 0s;
}
a::after{
  content: ' ';
  position: absolute;
  right: 0;
  bottom: 0;
  width: 10px;
  height: 10px;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  transition: 0.5s;
  transition-delay: 0.5s;
}
a:hover::after{
  width: 100%;
  height: 100%;
  transition-delay: 0s;
} */


.myinput{
  width: 75%;
  margin-right: auto;
  margin-left: auto;
}
.myinput /deep/ .el-input{
  margin-bottom: 20px;
}
.menu{
  width: 120px;
  
  border-radius: 2px;  
  /* display: none; */
  position: absolute;
  top:50px;
  left: -5%;
  color: #999;
  font-size: 14px;
  z-index: 100;
  transition: 0.5s;
  height: 0px;
}
.header-two:hover>.menu{
  /* transition-delay: 0.5s; */
  height:85px;
  background-color: #fff;
}
.header-two:hover>.menu>div{
  /* transition-delay: 0.5s; */
  height:40px;
  line-height: 40px;
}

.menu>div{
  height: 0px;
  text-align: center;
  overflow: hidden;
}

.menu>div:hover{
  background-color:#377bb5 ;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue